module.exports = __webpack_public_path__ + "assets/4f82e7f1d45404ad922d237ea5fbbd2d.mp3";